export enum LogLevel {
  Off = 0,
  Error,
  Warning,
  Info,
  Debug
}
